<template>
  <div class="form-review__images">
    <div class="--label h4">Добавьте фотографии</div>
    <div class="--items">
      <div
        v-for="(image, index) in model"
        :key="`image-uploaded-${index}`"
        class="--image"
      >
        <img
          :src="createImageUrl(image)"
          :alt="`добавленное изображение № ${index}`"
        />
        <div
          class="--remove"
          @click="() => removeImageFromForm(index)"
        />
      </div>
      <label class="--icon">
        <img
          src="~/assets/img/svg/common/image.svg"
          alt="изображение"
        />
        <input
          type="file"
          accept="image/jpeg,image/png"
          hidden
          multiple
          @change="uploadFormImages"
        />
      </label>
      <div
        v-if="model && model.length <= 0"
        class="--message h5"
      >
        Нажмите на кнопку или перетащите фото в эту область до 10 изображений в формате PNG, JPEG.
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const model = defineModel<File[] | undefined>();

function createImageUrl (image: Blob | MediaSource) {
  return URL.createObjectURL(image);
}

function uploadFormImages (event: Event) {
  const images = [...((event?.target as HTMLInputElement).files || [])];
  model.value ? model.value = [...model.value, ...images] : model.value = images;
  (event.target as HTMLInputElement).value = '';
}

function removeImageFromForm (index: number) {
  const images = [...model.value || []];
  images.splice(index, 1);
  model.value = images;
}
</script>

<style scoped lang="scss">
.form-review__images {
	margin-top: 32px;

	.--label {
		color: black;
		margin-bottom: 16px;
	}

	.--items {
		display: flex;
		flex-wrap: wrap;
		align-items: center;

		margin-top: -16px;
		margin-left: -16px;

		& > * {
			margin-top: 16px;
			margin-left: 16px;
		}
	}

	.--icon, .--image {
		width: calc(100% / 4 - 16px);
		max-width: 100px;
		position: relative;
		border-radius: 16px;
		overflow: hidden;

		img, video {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}

		&:after {
			content: "";
			float: left;
			padding-top: 100%;
		}
	}

	.--icon {
		background-color: #F4F3F1;
		cursor: pointer;

		img {
			width: 40px;
			filter: invert(60%) sepia(11%) saturate(9%) hue-rotate(111deg) brightness(99%) contrast(90%);
		}
	}

	.--image img,
	.--image video {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.--remove {
		position: absolute;
		top: 10px;
		right: 10px;
		width: 16px;
		height: 16px;
		background-color: white;
		border-radius: 100%;
		background-image: url("@/assets/img/svg/cart/plus.svg");
		background-size: 10px;
		background-position: center;
		background-repeat: no-repeat;
		transform: rotate(45deg);
		cursor: pointer;
	}

	.--message {
		color: #989898;
		flex: 1;
	}
}

@media (max-width: 1024px) {
	.form-review__images {
		flex-direction: column;
		align-items: flex-start;

		.--label {
			margin-bottom: 14px;
			font-size: 16px;
		}
	}
}
</style>
